import { WrappedFieldProps } from 'redux-form';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormError from 'dashboard/components/FormControls/FormError';
import PhoneInput, { PhoneInputProps } from 'dashboard/components/PhoneInput';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';

export default (props: WrappedFieldProps & PhoneInputProps & { label?: string }) => {
  const {
    input,
    meta: { error, submitFailed, touched },
    label,
    id,
    ...passthroughProps
  } = props;

  const hasError = !!(error && (submitFailed || touched));

  return (
    <FormGroup>
      {label && <FormControlLabel htmlFor={id}>{label}</FormControlLabel>}
      <PhoneInput {...input} {...passthroughProps} hasError={hasError} id={id} />
      {hasError && <FormError>{error}</FormError>}
    </FormGroup>
  );
};
